import i18n from "i18next";
import type { FC } from "react";
import { useNavigate } from "react-router";

import { BASE_PATH, FORM_ACTION } from "../../core/router/types/routerTypes";
import { PrimaryButton } from "../Buttons/components/ActionButton";

export type AddButtonProps = {
    resourceName?: string;
    isDisabled?: boolean;
    callback?: () => void;
    name?: string;
};

export const AddButton: FC<AddButtonProps> = ({ name, resourceName, isDisabled, callback }) => {
    const navigate = useNavigate();
    const onClick = () => navigate(`${BASE_PATH}/${resourceName}/${FORM_ACTION.CREATE}`);

    return (
        <PrimaryButton name={name || "add_button"} onClick={callback || onClick} disabled={isDisabled || false}>
            {i18n.t("button.add")}
        </PrimaryButton>
    );
};
